import { Modal, Typography, Button } from '@scale/scaleui';
import { ComponentProps, ReactNode, memo } from 'react';
import { useChatThemeStore } from '../ThreadedInteraction/hooks/useChatThemeStore';

const HourglassIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width={112}
    height={65}
    viewBox="0 0 112 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 0.5H28H60H64C66.125 0.5 68 2.375 68 4.5C68 6.75 66.125 8.5 64 8.5V9.875C64 15.25 61.875 20.375 58.125 24.125L49.625 32.5L54.125 37C52.75 39.875 52 43.125 52 46.5C52 54 55.625 60.625 61.25 64.5H60H28H24C21.75 64.5 20 62.75 20 60.5C20 58.375 21.75 56.5 24 56.5V55.125C24 49.875 26 44.75 29.75 41L38.25 32.5L29.75 24.125C26 20.375 24 15.25 24 9.875V8.5C21.75 8.5 20 6.75 20 4.5C20 2.375 21.75 0.5 24 0.5ZM32 9.875C32 12.25 32.625 14.625 34 16.5H54C55.25 14.625 56 12.25 56 9.875V8.5H32V9.875ZM92 46.5C92 56.5 83.875 64.5 74 64.5C64 64.5 56 56.5 56 46.5C56 36.625 64 28.5 74 28.5C83.875 28.5 92 36.625 92 46.5ZM74 36.5C72.875 36.5 72 37.5 72 38.5V46.5C72 47.625 72.875 48.5 74 48.5H80C81 48.5 82 47.625 82 46.5C82 45.5 81 44.5 80 44.5H76V38.5C76 37.5 75 36.5 74 36.5Z"
      fill="url(#paint0_linear_1_1878)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_1878"
        x1={0}
        y1={32.4861}
        x2={112.01}
        y2={32.4861}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1AAD7" />
        <stop offset={0.25} stopColor="#C88BC4" />
        <stop offset={0.5} stopColor="#7B8FDD" />
        <stop offset={0.7486} stopColor="#86BFF2" />
        <stop offset={0.9987} stopColor="#BBDEF2" />
      </linearGradient>
    </defs>
  </svg>
);

interface ClaimModalProps {
  confirmButtonText: string;
  onConfirmButtonClick: () => void;
  isConfirmButtonLoading?: boolean;
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
  isSecondaryButtonLoading?: boolean;
  title?: string;
  subtitle?: ReactNode;
  timer?: string;
}

function ClaimModal({
  confirmButtonText,
  title,
  subtitle,
  timer,
  secondaryButtonText,
  onSecondaryButtonClick,
  onConfirmButtonClick,
  isConfirmButtonLoading,
  isSecondaryButtonLoading,
}: ClaimModalProps) {
  const theme = useChatThemeStore(state => state.theme);
  return (
    <Modal
      open
      innerClassName={theme}
      title={title}
      actions={
        <div className="flex gap-2 justify-end">
          <Button
            size="lg"
            onClick={onConfirmButtonClick}
            disabled={isConfirmButtonLoading}
            isLoading={isConfirmButtonLoading}
          >
            {confirmButtonText}
          </Button>
          {secondaryButtonText && (
            <Button
              size="lg"
              variant="white"
              onClick={onSecondaryButtonClick}
              disabled={isSecondaryButtonLoading}
              isLoading={isSecondaryButtonLoading}
            >
              {secondaryButtonText}
            </Button>
          )}
        </div>
      }
    >
      <div className="flex flex-col gap-4 items-center my-[94px] mx-4 w-[500px] py-8">
        <HourglassIcon />
        {title && <Typography.H4>{title}</Typography.H4>}
        {timer && <Typography.H2>{timer}</Typography.H2>}
        {subtitle && (
          <Typography.Paragraph2 className="text-center">{subtitle}</Typography.Paragraph2>
        )}
      </div>
    </Modal>
  );
}

export default memo(ClaimModal);
